<template>
    <div class="secPwdView" @touchmove.preven>
        <div class="secPwdBox">
            <div class="close-box" @click="closePwdBox">
                <icon >shangpinjiesuan-anquanmimadanchuangguanbi</icon>
            </div>
            <div class="title">安全密码</div>
            <div class="tips">为保障资金安全，请输入安全密码</div>
            <div class="pwd-input">
                <code-input
                    class="code-input"
                    len="6"
                    isPassword="true"
                    @code-value="codeVal"
                    size="40"
                    ref="pwd">
                </code-input>
            </div>
            <div class="alert">
              <div class="sec-pwd-message">{{ secPwdMessage }}</div>
              <div class="to-personal-center" @click="goToSetSecPwd(1)">
                  忘记密码
              </div>
            </div>
        </div>
    </div>
</template>
<script>
    import codeInput from './code_input.vue'
    import icon from '../../../components/icon.vue'
    import cookie from '../../../lib/cookie.js'
    import CONSTANT_COOKIE from '../../../constant/cookie.js'
    import { getHostName } from '../../../util/function.js'
    export default {
        props:['secPwd', 'secPwdMessage'],
        data() {
            return {
                // secPwd:''
            }
        },
        components: {
            codeInput,
            icon,
        },
        methods: {
            closePwdBox() {
                this.$emit("close-box")
                this.$refs.pwd.reset()
            },
            goToSetSecPwd(hasSeted) {
                cookie(CONSTANT_COOKIE.COOKIE_USER_INFO_HAS_PAY_PASSWORD,hasSeted)
                location.href = `${getHostName()}/mz-auth/#/user/security-code`
            },
            reset() {
                this.$refs.pwd.reset()
            },
            codeVal(val) {
                this.$emit('code-value', val)
            },
        },
    }
</script>
